<template>
  <component :is="'script'" type="application/ld+json" v-html="serialized" />
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  data: Record<string, unknown> | Array<Record<string, unknown>>
}>()

const serialized = computed(() => JSON.stringify(props.data))
</script>
